angular.module('nv.singleStudent').component('studentRegentsPanelBoxes', {
  // tslint:disable-next-line:max-line-length
  template: require('./student-regents-panel-boxes.html'),
  bindings: {
    student: '<',
    examsWithNoPlan: '<',
  },
  controller: 'StudentRegentsPanelBoxesCtrl',
});
